<iw-info-dialog-content
  [status]="status"
  [iconName]="iconName"
  [title]="title | translate"
>
  <div afterTitle>
    <div class="subtitle d-flex flex-col align-center">
      <p>{{ message | translate }}</p>
      @if (note) {
        <p class="note">{{ note | translate }}</p>
      }
    </div>
    <div class="actions">
      <iw-button
        size="m"
        fullWidth
        class="action"
        uiType="secondary"
        (click)="cancel()"
      >
        {{ cancelText | translate }}
      </iw-button>
      @if (supportBtn) {
        <iw-button
          size="m"
          fullWidth
          class="action"
          uiType="primary"
          (click)="openSupport()"
        >
          {{ "confirmDialog.btn.support" | translate }}
        </iw-button>
      } @else {
        <iw-button
          size="m"
          fullWidth
          class="action"
          uiType="primary"
          (click)="confirm()"
        >
          {{ confirmText | translate }}
        </iw-button>
      }
    </div>
  </div>
</iw-info-dialog-content>
